// ============================================================================
// CHINESE TRADITIONAL TRANSLATIONS - CHAPTER 2: 出埃及記
// ============================================================================
// 級別 14-26 (13級別, 39問題)

export const chapter2Translations = {
  name: '出埃及記',
  description: '上帝子民的解放……認識上帝改變我們的生活',
  
  spiritualWisdom: {
    principle: '對上帝的認識能解放和改變人',
    scripture: '你們必曉得真理,真理必叫你們得以自由(約翰福音8:32)',
    application: '正如以色列從埃及得解放,對上帝的認識使我們從屬靈的奴役中得自由'
  },
  
  levels: {
    14: {
      name: '摩西從水中獲救',
      challenge: '那婦人懷孕,生了一個兒子,見他俊美...',
      easy: {
        question: '摩西的母親把他藏在什麼裡面?',
        options: ['山洞', '蒲草箱', '籃子', '房子'],
        hint: '這個容器漂浮在尼羅河上',
        funFact: '🏺 蒲草箱塗了瀝青以防水!'
      },
      medium: {
        question: '誰在蘆葦中發現了摩西?',
        options: [
          '法老的女兒',
          '埃及女僕',
          '他的姐姐米利暗',
          '埃及祭司'
        ],
        hint: '埃及王室的一員',
        funFact: '👑 具有諷刺意味的是,法老的家人拯救了將挑戰他的人!'
      },
      hard: {
        question: '神的護理如何使用我們的敵人?',
        options: [
          '通過使他們改變信仰',
          '通過安排環境來實現祂的旨意',
          '通過懲罰他們',
          '通過忽視他們'
        ],
        hint: '這是關於在事件中看到上帝的手',
        funFact: '✨ 摩西在壓迫他族人的人的宮殿中長大!'
      }
    },
    
    15: {
      name: '燃燒的荊棘',
      challenge: '耶和華的使者從荊棘火焰中向他顯現...',
      easy: {
        question: '摩西在燃燒的荊棘前應該脫掉什麼?',
        options: ['珠寶', '鞋子', '外套', '頭巾'],
        hint: '穿在腳上的東西',
        funFact: '👡 脫鞋表達對聖地的尊重!'
      },
      medium: {
        question: '上帝向摩西啟示了什麼名字?',
        options: [
          '耶和華',
          '自有永有',
          '全能者',
          '造物主'
        ],
        hint: '一個表達絕對存在的名字',
        funFact: '🔥 YHWH(我是)啟示了上帝的永恆本質!'
      },
      hard: {
        question: '燃燒卻不被燒毀的荊棘教導我們什麼?',
        options: [
          '魔法存在',
          '上帝超越自然法則',
          '火是神聖的',
          '植物是神奇的'
        ],
        hint: '這是關於超越我們理解的神性',
        funFact: '🌿 荊棘象徵著神的同在能使之成聖而不毀滅!'
      }
    },

    16: {
      name: '埃及的十災',
      challenge: '法老心裡剛硬,不聽他們的話...',
      easy: {
        question: '埃及的第一場災難是什麼?',
        options: ['青蛙', '水變成血', '蒼蠅', '蝨子'],
        hint: '它影響了埃及的生命之源尼羅河',
        funFact: '🩸 尼羅河被當作神來崇拜,上帝顯示了祂的優越性!'
      },
      medium: {
        question: '最後也是最可怕的災難是什麼?',
        options: [
          '冰雹',
          '黑暗',
          '長子之死',
          '蝗蟲'
        ],
        hint: '這場災難直接影響了家庭',
        funFact: '😢 這場災難最終打破了法老的驕傲並釋放了以色列!'
      },
      hard: {
        question: '為什麼上帝使法老的心剛硬?',
        options: [
          '為了懲罰他',
          '為了彰顯祂的榮耀和能力',
          '出於惡意',
          '為了延長苦難'
        ],
        hint: '這是關於顯明真神是誰',
        funFact: '⚡ 災難證明YHWH比所有埃及神都更強大!'
      }
    },

    17: {
      name: '逾越節',
      challenge: '取一隻羊羔……把血塗在門楣和門框上...',
      easy: {
        question: '以色列人應該把羊羔的血塗在哪裡?',
        options: [
          '衣服上',
          '門楣和門框上',
          '額頭上',
          '杯子裡'
        ],
        hint: '在房屋的入口處',
        funFact: '🩸 門上的血是神保護的標記!'
      },
      medium: {
        question: '應該如何吃逾越節的羊羔?',
        options: [
          '舒適地坐著',
          '只和家人一起',
          '腰間束帶,腳上穿鞋,手中拿杖',
          '沈默中'
        ],
        hint: '準備出發',
        funFact: '🚶 他們必須準備好迅速出發走向自由!'
      },
      hard: {
        question: '逾越節羔羊如何預表基督?',
        options: [
          '通過它的白色',
          '通過替代性犧牲拯救免於死亡',
          '通過它的溫順',
          '通過它的年齡'
        ],
        hint: '這是關於免於定罪的犧牲',
        funFact: '🐑 耶穌被稱為除去世人罪孽的上帝的羔羊!'
      }
    },

    18: {
      name: '穿越紅海',
      challenge: '摩西向海伸杖...',
      easy: {
        question: '以色列人如何穿越大海?',
        options: [
          '坐船',
          '游泳',
          '走乾地',
          '用木筏'
        ],
        hint: '海底變得可以行走',
        funFact: '🌊 上帝把障礙變成了解放之路!'
      },
      medium: {
        question: '追趕的埃及人發生了什麼事?',
        options: [
          '他們轉身回去',
          '他們被水吞沒',
          '他們迷路了',
          '他們加入了以色列'
        ],
        hint: '水回到他們身上',
        funFact: '⚔️ 世界上最強大的軍隊在瞬間被摧毀!'
      },
      hard: {
        question: '這次穿越在我們的屬靈生活中象徵什麼?',
        options: [
          '逃避問題',
          '從罪的奴役過渡到在上帝裡的自由',
          '以色列的優越性',
          '敵人的毀滅'
        ],
        hint: '這是關於屬靈的轉變',
        funFact: '🗽 紅海代表洗禮:向舊事死,新生命!'
      }
    },

    19: {
      name: '曠野的嗎哪',
      challenge: '這是什麼?因為他們不知道這是什麼...',
      easy: {
        question: '嗎哪降了多長時間?',
        options: ['10年', '20年', '40年', '50年'],
        hint: '與在曠野的年數相同',
        funFact: '🍞 40年間,上帝奇蹟般地餵養了200萬人!'
      },
      medium: {
        question: '如果保存嗎哪超過一天會發生什麼?',
        options: [
          '變得更美味',
          '倍增',
          '腐爛發臭',
          '變硬'
        ],
        hint: '安息日前的星期五除外',
        funFact: '🪱 上帝這樣教導人每天依靠祂!'
      },
      hard: {
        question: '嗎哪如何教導我們信靠?',
        options: [
          '為將來儲備',
          '依靠上帝每日的供應',
          '更努力工作',
          '公平分享'
        ],
        hint: '這是關於每日的信靠',
        funFact: '🙏 我們日用的飲食,今日賜給我們源於這個經歷!'
      }
    },

    20: {
      name: '磐石的水',
      challenge: '擊打磐石,就有水從其中流出來……',
      easy: {
        question: '摩西應該如何擊打磐石?',
        options: ['用手', '用杖', '用腳', '用劍'],
        hint: '上帝給他的工具',
        funFact: '🪨 簡單的順服引發了超自然的奇蹟!'
      },
      medium: {
        question: '為什麼百姓口渴?',
        options: [
          '因為炎熱',
          '因為沙漠中沒有水',
          '因為長途旅行',
          '因為疾病'
        ],
        hint: '這是關於他們的環境',
        funFact: '💧 上帝在乾旱的沙漠中創造了水源!'
      },
      hard: {
        question: '這磐石如何預表基督?',
        options: [
          '通過它的力量',
          '被擊打並給出生命的水',
          '通過它的大小',
          '通過它的位置'
        ],
        hint: '這是關於救恩的源泉',
        funFact: '⚡ 保羅說:那磐石就是基督(哥林多前書10:4)!'
      }
    },

    21: {
      name: '十誡',
      challenge: '上帝吩咐這一切的話說……',
      easy: {
        question: '上帝在哪裡賜下十誡?',
        options: ['在埃及', '在西奈山', '在迦南', '在曠野'],
        hint: '有火和煙的聖山',
        funFact: '🔥 上帝的同在使整座山震動!'
      },
      medium: {
        question: '十誡刻在什麼上?',
        options: [
          '羊皮紙上',
          '用上帝的指頭刻在石板上',
          '木頭上',
          '金子上'
        ],
        hint: '永久的材料',
        funFact: '👆 上帝親自寫下祂的律法!'
      },
      hard: {
        question: '律法的目的是什麼?',
        options: [
          '拯救人',
          '顯明罪並顯示上帝的聖潔本性',
          '懲罰人',
          '奴役人'
        ],
        hint: '這是關於顯明上帝的標準',
        funFact: '📜 律法引導我們認識需要基督!'
      }
    },

    22: {
      name: '金牛犢',
      challenge: '他們摘下金飾,拿來給亞倫……',
      easy: {
        question: '摩西不在時,百姓做了什麼?',
        options: [
          '新帳篷',
          '金牛犢',
          '金紀念碑',
          '新祭壇'
        ],
        hint: '偶像崇拜的對象',
        funFact: '🐄 他們拋棄了解放之神去侍奉偶像!'
      },
      medium: {
        question: '摩西對這罪如何反應?',
        options: [
          '很高興',
          '發怒並摔碎石板',
          '逃跑',
          '忽視'
        ],
        hint: '他的激烈反應',
        funFact: '😢 當上帝的律法被破壞時,摩西摔碎了律法!'
      },
      hard: {
        question: '為什麼人心傾向偶像?',
        options: [
          '因為無知',
          '渴望依靠看得見的東西和對上帝主權的反抗',
          '因為魔鬼的影響',
          '因為軟弱'
        ],
        hint: '這是關於人性和對可見之物的渴望',
        funFact: '💔 偶像崇拜用受造物取代造物主!'
      }
    },

    23: {
      name: '會幕',
      challenge: '又當為我造聖所……',
      easy: {
        question: '會幕是什麼?',
        options: [
          '宮殿',
          '上帝的移動聖所',
          '倉庫',
          '學校'
        ],
        hint: '上帝同在的地方',
        funFact: '⛺ 上帝渴望住在祂子民中間!'
      },
      medium: {
        question: '會幕中最神聖的地方是哪裡?',
        options: [
          '祭壇',
          '至聖所',
          '入口',
          '陳設餅桌'
        ],
        hint: '約櫃所在的地方',
        funFact: '✨ 只有大祭司一年一次可以進入那裡!'
      },
      hard: {
        question: '會幕預表什麼?',
        options: [
          '以色列的力量',
          '以馬內利,上帝與我們同在,由基督成就',
          '祭司的重要性',
          '儀式的美麗'
        ],
        hint: '這是關於上帝住在人中間',
        funFact: '🙏 耶穌在我們中間搭了帳幕(約翰福音1:14)!'
      }
    },

    24: {
      name: '迦南的探子',
      challenge: '打發人去窺探那地和居民……',
      easy: {
        question: '派了多少探子去窺探迦南?',
        options: ['6個', '10個', '12個', '24個'],
        hint: '以色列每個支派一個',
        funFact: '🕵️ 派了12個,但只有2個有信心!'
      },
      medium: {
        question: '有信心的兩個探子是誰?',
        options: [
          '摩西和亞倫',
          '約書亞和迦勒',
          '亞倫和米利暗',
          '基甸和參孫'
        ],
        hint: '活著進入迦南的人',
        funFact: '💪 他們的信心在漂流40年後得到了回報!'
      },
      hard: {
        question: '不信的後果是什麼?',
        options: [
          '立即被赦免',
          '在曠野漂流40年',
          '立即受罰',
          '被放逐'
        ],
        hint: '長期的後果',
        funFact: '😢 恐懼使整整一代人失去了進入應許之地!'
      }
    },

    25: {
      name: '銅蛇',
      challenge: '火蛇進入百姓中間,咬他們……',
      easy: {
        question: '咬百姓的是什麼蛇?',
        options: ['綠色的', '火蛇', '巨大的', '看不見的'],
        hint: '描述其致命效果的形容詞',
        funFact: '🐍 這些蛇象徵著罪的致命後果!'
      },
      medium: {
        question: '上帝命令摩西做什麼來拯救百姓?',
        options: [
          '製藥',
          '在桿上舉起銅蛇',
          '禱告',
          '殺死蛇'
        ],
        hint: '信心的行動',
        funFact: '⚕️ 簡單的仰望行為就能得救-象徵信心!'
      },
      hard: {
        question: '耶穌談到十字架時如何引用這事件?',
        options: [
          '關於罪的危險',
          '摩西在曠野怎樣舉蛇,人子也必照樣被舉起來',
          '關於順服的必要',
          '關於禱告的能力'
        ],
        hint: '這是關於因信得救',
        funFact: '✝️ 耶穌像銅蛇一樣被舉起來拯救罪人!'
      }
    },

    26: {
      name: '應許之地',
      challenge: '你可以眼看那地,卻不得進去……',
      easy: {
        question: '誰帶領以色列過約旦河?',
        options: ['摩西', '亞倫', '約書亞', '迦勒'],
        hint: '摩西的繼承人',
        funFact: '🚶 約書亞的名字與耶穌同義:耶和華拯救!'
      },
      medium: {
        question: '為什麼摩西不能進入應許之地?',
        options: [
          '太老了',
          '因為在米利巴水邊不順服',
          '拒絕帶領百姓',
          '生病了'
        ],
        hint: '以前的特定罪',
        funFact: '😢 即使摩西也面對了不順服的後果!'
      },
      hard: {
        question: '應許之地象徵什麼?',
        options: [
          '物質財富',
          '上帝在基督裡應許的成就和我們天上的基業',
          '以色列的軍事勝利',
          '曠野的結束'
        ],
        hint: '這是關於上帝應許的屬靈成就',
        funFact: '🌿 迦南指向等待我們的天上家鄉!'
      }
    }
  }
};

export default chapter2Translations;
